import { AbstractSearchArgument } from '../global'

class SearchArgument extends AbstractSearchArgument {
  constructor () {
    super()
    this.itemId = ''
  }
}

export {
  SearchArgument
}



// WEBPACK FOOTER //
// ./src/models/client/work-bench.js